module.exports = __webpack_public_path__ + "assets/img/emma_charles.7b72d67c.jpeg";